import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { AuthShell } from "./Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Forgot() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [pwd, setPwd] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const sendCode = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      if (data.dev_otp) toast.info(`Demo reset code: ${data.dev_otp}`, { duration: 10000 });
      toast.success("Reset code sent");
      setStep(2);
    } catch (e) { setError(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  const reset = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try {
      await api.post("/auth/reset-password", { email, otp, new_password: pwd });
      toast.success("Password reset! Please login.");
      navigate("/login");
    } catch (e) { setError(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell title="Reset password" subtitle={step === 1 ? "Enter your email to receive a reset code" : "Enter the code and your new password"}>
      {step === 1 ? (
        <form onSubmit={sendCode} className="space-y-4">
          <div><Label>Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" required /></div>
          {error && <p className="text-crimson text-sm">{error}</p>}
          <Button type="submit" className="w-full viriks-navy text-white" disabled={loading} data-testid="send-code-btn">{loading ? "Sending..." : "Send Reset Code"}</Button>
        </form>
      ) : (
        <form onSubmit={reset} className="space-y-4">
          <div><Label>Reset Code</Label><Input value={otp} onChange={(e) => setOtp(e.target.value)} data-testid="reset-otp" required /></div>
          <div><Label>New Password</Label><Input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="reset-password" required /></div>
          {error && <p className="text-crimson text-sm">{error}</p>}
          <Button type="submit" className="w-full viriks-navy text-white" disabled={loading} data-testid="reset-submit">{loading ? "Resetting..." : "Reset Password"}</Button>
        </form>
      )}
      <p className="text-center text-sm text-muted-foreground mt-6"><Link to="/login" className="text-amber font-semibold">Back to login</Link></p>
    </AuthShell>
  );
}
